module.exports = __webpack_public_path__ + "static/media/file-medical-alt.8de3eb11.svg";